<div class="back-container">
    <div class="back" routerLink="/">
        <frg-inline-svg stroke="var(--primary)" class="back-icon" src="assets/icons/chevron-left.svg"></frg-inline-svg>
        <div class="back-text">Connexion</div>
    </div>
</div>
<form [formGroup]="profilForm" class="profil-card-content" (ngSubmit)="onSubmit()">
    <div class="profil-list-container">
        <div class="profil-list-title">Liste des cabinets associés</div>
        <div class="profil-list-search-container">
            <div class="search-container">
                <div class="search-input">
                    <frg-search-input (search)="search = $event"></frg-search-input>
                </div>
            </div>
            <div class="profil-list" [ngClass]="{'hidden': (!profils || profils.length === 0)}">
                <ng-container *ngFor="let profil of profils | search : search : 'profil-office'">
                    <label class="profil" [ngClass]="{'disabled': profil.disabled}">
                        <div class="profil-nom">{{profil.cabinet.nom}} <span *ngIf="profil.cabinet.adresse">({{profil.cabinet.adresse}})</span></div>
                        <input [id]="profil.cabinet.nom" type="radio" [value]="profil" formControlName="profil" />
                    </label>
                </ng-container>
                <div class="no-element" *ngIf="(profils | search : search : 'profil-office').length === 0">
                    Aucun élément ne correspond à votre recherche
                </div>
            </div>
            <div class="lds-spinner-container" [ngClass]="{'hidden': profils && profils.length !== 0}">
                <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    </div>
    <div class="buttons-container">
        <div class="connect-button-container">
            <button type="submit" class="button mail-login">
                Se connecter
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>
</form>